import { render, staticRenderFns } from "./DeployedInstance.vue?vue&type=template&id=53b83802&scoped=true&"
import script from "./DeployedInstance.vue?vue&type=script&lang=js&"
export * from "./DeployedInstance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b83802",
  null
  
)

export default component.exports